export const pointerEventButtons = {
  LEFT: 0b1,
  RIGHT: 0b10,
  MIDDLE: 0b100,
};
